import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { compose } from "redux";
import { t } from "i18next";

import { getCurrentAuthUser } from "../../utils/authorization";
import shippingApi from "../../api/shippingApi";
import palletApi from "../../api/palletApi";
import poApi from "../../api/poApi";

import ReactTableBuilder from "../../utils/reactTableBuilder";
import { Box, Divider, IconButton } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import UndoIcon from '@mui/icons-material/Undo';
import { StandardPage, StandardPageTopContent, StandardPageMainContent, MuiCol, MuiRow, MuiBox } from "../../components/layout";
import { MuiSelect, ScannerInput, MuiTextArea, MuiTextField, MuiCheckbox } from '../../components/inputs';

function ShippingCM(props) {
  const { t } = props;
  const [scannerValue, setScannerValue] = useState();
  const [noInvoiceChecked, setNoInvoiceChecked] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [poList, setPoList] = useState([]);

  useEffect(()=>{
    getCurrentAuthUser().then((res)=>{
      loadPoFromCM(res.plant.netsuiteCmId);
    })
  },[])
  
  async function loadPoFromCM(cmId) {
    return poApi.getOpenPoOnCm(cmId)
      .then(result => {
        if(result.data.status ==="success") {
          let pos = result.data.data.pos;

          pos.sort((a,b) => (a.tranName > b.tranName) ? 1 : ((b.tranName > a.tranName) ? -1 : 0))
          setPoList(pos);
        }
      });
  }

  function scannerOnKeyDown(e){
    if (e.key === 'Enter') {
      if(scannerValue && scannerValue !== "")
        palletScanned(scannerValue);
    }
  }

  function palletScanned(palletBarcode){
    palletApi.getPallet(palletBarcode).then((res)=>{
      const poNumbers = res.data.cameras.reduce((acc, cam) => {
        if (cam.poNumber && !acc.includes(cam.poNumber)) {
          acc.push(cam.poNumber);
        }
        return acc;
      }, []);
      const poLabels = poList.filter(po => poNumbers.includes(po.poId));

      setStatusOnPallet(res.data, "readyForShipping").then(()=>{
        setTableData(current => [...current, {
          ...res.data,
          poLabels:poLabels
        }]);
      }).catch((err)=>{
        console.log('ERROR', err);
        alert('ERROR!!');
      })
    });
  }

  function revertPalletShipping(pallet) {
    setStatusOnPallet(pallet, "packed").then(()=>{
      setTableData(current => {
        return current.filter(row=> row.barcode !== pallet.barcode)
      });
    }).catch((err)=>{
      console.log('ERROR', err);
      alert('ERROR!!');
    })
  }

  function setStatusOnPallet(pallet, status) {
    return palletApi.updatePallet(pallet.barcode,{
      status: status,
    });
  }



  const columns =
  [
    {
      Header: 'Pallet Number',
      accessor: 'barcode',
    },
    {
      Header: 'PO Number(s)',
      accessor: (row, index)=>{
        return (
          <>
            {
              row.poLabels.map(po => po.tranNumber).join(" / ")
            }
          </>
        );
      },
    },
    {
      Header: 'Revert Item',
      accessor: (row, index)=>{
        return (
          <IconButton variant="contained" color="info" aria-label="delete" onClick={()=>{revertPalletShipping(row)}}>
            <UndoIcon />
          </IconButton>
        );
      },
    },
  ]

  return (
    <>
      <StandardPage
        title={t("dashboard_main.shipmentCM")}
        description={t("dashboard_main.shipment_desc_autosave_po")}
      >
        <StandardPageTopContent>
          <MuiRow>
            <MuiCol size={{xs:12, md:12}}>
              <ScannerInput
                onChange={setScannerValue}
                onKeyDown={scannerOnKeyDown}
                value={scannerValue}
                label={t("dashboard_main.scanner")}
              />
            </MuiCol>
            {/*<MuiCol size={{xs:12, md:4}}>
               <MuiCheckbox label={t("dashboard_main.noInvoice")} 
                value={noInvoiceChecked} 
                onChange={setNoInvoiceChecked} /> 
            </MuiCol>*/}
          </MuiRow>
          {/* <MuiRow spacing={2} sx={{height:"150px"}}>
            <MuiCol size={{xs:12, md:4}}>

            </MuiCol>
            <MuiCol size={{xs:12, md:4}}>
              <MuiBox greyBox sx={{height:"130px"}}>
              <span>{ t('inventory.shipping.billTo') }</span>
              </MuiBox>
            </MuiCol>
            <MuiCol size={{xs:12, md:4}}>
              <MuiBox greyBox sx={{height:"130px"}}>
                <span>{ t('inventory.shipping.shipTo') }</span>
              </MuiBox>
            </MuiCol>
          </MuiRow> */}
        </StandardPageTopContent>
        <StandardPageMainContent>
          <ReactTableBuilder columns={columns} data={tableData} maxRows={9}/>
        </StandardPageMainContent>
      </StandardPage>
    </>
  );
}

ShippingCM.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors
});

export default compose(
  withTranslation(),
  connect(
    mapStateToProps,
  )
)(ShippingCM);